import { useMediaQuery } from '@mantine/hooks';
import { useDownloadContract } from 'hooks/useDownloadContract';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useGetEmployedQuery } from 'redux/Api/employedsApi/employedsApi';
import { StatusProfileContent } from './StatusProfileContent';
import { ContractsProfileContent } from './ContractsProfileContent';
import { ReferencesProfileContent } from './ReferencesProfileContent';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import styles from './EmployedsProfileContent.module.scss';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { ReactComponent as BackBtn } from './img/iconChewronForward.svg';
import { Affix, Box, Loader } from '@mantine/core';
import { Avatar } from 'components/Avatar';
import { getProblem } from './GetProblem';
import { TabMenu } from 'components/TabMenu';
import { Modal } from 'components/Modal';
import { CreateContractForm } from 'components/CreateContractForm';
import { ModalConfirm } from 'components/ContractItem/ModalConfirm';
import { CreateDownloadReferenceHandler } from './createDownloadReferenceHandler';
import {
  getErrorCreateContractMessage,
  REFERENCE_MODAL_MESSAGES,
  tabs,
} from './EmployedsProfileContentDesktop';
import { CreateEmployedsСategory } from '../../components/CreateEmployedsСategory';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';

export const formatPhone = (phone: string) => {
  if (!phone) return '';
  return `+${phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5')}`;
};

export const EmployedsProfileContentMobile = () => {
  const { id } = useParams();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    data: worker,
    isLoading,
    error,
    refetch,
  } = useGetEmployedQuery({ id: Number(id) });
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [referencesRefetch, setReferencesRefetch] = useState<(() => void) | null>(null);
  const [referenceModalContent, setReferenceModalContent] = useState<{
    title: string;
    text: string;
  }>({ title: '', text: '' });
  const [showReferenceModal, setShowReferenceModal] = useState(false);
  const [isLoadingDownloading, setIsLoadingDownloading] = useState(false);
  const [contractData, setContractData] = useState<{ id: number; number: string } | null>(
    null,
  );

  const { handleDownloadContract } = useDownloadContract({
    contractId: contractData?.id || null,
    contractNumber: contractData?.number || null,
    setIsLoadingDownloading,
  });

  const { data: dataProfile } = useGetProfileQuery();
  const isTetrika = dataProfile?.settings?.tetrika;

  const [active, setActive] = useState<string>('status');
  const [showNewContract, setShowNewContract] = useState(false);
  const [isLoadingReference, setIsLoadingReference] = useState(false);
  const [isCreatedModalOpen, setIsCreatedModalOpen] = useState(false);
  const [showCopiedSuccess, setShowCopiedSuccess] = useState(false);
  const handleCloseCopiedSuccess = () => {
    setShowCopiedSuccess(false);
  };

  const downloanHandle = CreateDownloadReferenceHandler(id, dispatch);

  useEffect(() => {
    if (error) {
      navigate('/employees');
    }
  }, [error, navigate]);

  useEffect(() => {
    if (isMobile) {
      document.body.style.backgroundColor = '#fff';
    }

    return () => {
      document.body.style.backgroundColor = '';
    };
  }, [isMobile]);

  const [isWorkerHasContract, setIsWorkerHasContract] = useState<number>(0);

  const handleDataFromChild = (newData: number) => {
    setIsWorkerHasContract(newData);
  };

  const content: Record<string, React.ReactNode> = {
    status: worker ? (
      <StatusProfileContent
        worker={worker}
        refetch={refetch}
        setIsCreatedModalOpen={setIsCreatedModalOpen}
      />
    ) : null,
    contracts: (
      <ContractsProfileContent worker={worker} sendDataToParent={handleDataFromChild} />
    ),
    references: (
      <ReferencesProfileContent
        worker={worker}
        onRefetchReady={(refetchFn) => setReferencesRefetch(() => refetchFn)}
      />
    ),
  };

  const isWorkerFnsStatus =
    (worker?.worker_app?.fns_status ?? -1) <= 0 || worker?.worker_app?.fns_status === 3;

  const isDisabledLoadReference = !isLoadingReference;

  if (isLoading) {
    return <LoadingSkeleton mt />;
  }

  return (
    <>
      <Helmet>
        <title>
          {isLoading
            ? 'Исполнитель'
            : `${worker?.surname || ''} ${worker?.name || ''} ${
                worker?.patronymic || ''
              }`}
        </title>
      </Helmet>
      <div className={styles.rootMobile}>
        <Link to='/employees' className={styles.linkMobile}>
          <BackBtn />
          Избранные исполнители
        </Link>

        <div className={styles.mainMobile}>
          <div className={styles.userMobile}>
            <div className={styles.infoMobile}>
              <div className={styles.avatarMobile}>
                <div className={styles.avatarMobile_wrapper}>
                  <Avatar
                    name={worker?.name || ''}
                    surname={worker?.surname || ''}
                    avatar={worker?.worker_app?.avatar ?? null}
                    id={worker?.id}
                    statusActive={''}
                    height={'64px'}
                    width={'64px'}
                    isDeleted={worker?.is_deleted}
                  />
                </div>
                <div className={styles.textWrapperMobile}>
                  <span className={styles.nameMobile}>
                    {worker?.surname} {worker?.name} {worker?.patronymic}
                  </span>
                  {getProblem(worker, styles.textMobile_status)}
                </div>
              </div>
              <div className={styles.textMobile}>
                <div>
                  <span>{formatPhone(worker?.phone ?? '')}</span>
                  <span>ИНН {worker?.inn}</span>
                </div>
                <div>
                  <span>
                    {worker?.worker_app?.nationality || 'Гражданство неизвестно'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.tabsMobile}>
            <TabMenu lists={tabs} active={active} setActive={setActive} />
            {active === 'contracts' && worker?.worker_app?.nationality !== 'Россия' && (
              <Affix
                hiddenFrom='sm'
                position={{ bottom: 34, right: 0, left: 0 }}
                w='fit-content'
                m='0 auto'
                style={{ display: 'flex', justifyContent: 'center' }}>
                <Box
                  p='12px'
                  h='48px'
                  w='214px'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    color: isDisabledLoadReference ? 'white' : '#8E9AA8',
                    borderRadius: '4px',
                    cursor: isDisabledLoadReference ? 'pointer' : 'not-allowed',
                    backgroundColor: isDisabledLoadReference ? '#002CFB' : '#f1f4f9',
                  }}
                  onClick={() => {
                    if (!worker?.worker_app) {
                      setReferenceModalContent(REFERENCE_MODAL_MESSAGES.NO_APP_CONTRACT);
                      setShowReferenceModal(true);
                    } else if (isWorkerFnsStatus) {
                      setReferenceModalContent(
                        REFERENCE_MODAL_MESSAGES.FNS_STATUS_CONTRACT,
                      );
                      setShowReferenceModal(true);
                    } else if (isTetrika && isWorkerHasContract > 1) {
                      setReferenceModalContent(
                        getErrorCreateContractMessage(isWorkerHasContract),
                      );
                      setShowReferenceModal(true);
                    } else if (!isTetrika && isWorkerHasContract) {
                      setReferenceModalContent(
                        getErrorCreateContractMessage(isWorkerHasContract),
                      );
                      setShowReferenceModal(true);
                    } else if (worker.is_in_stoplist) {
                      setReferenceModalContent(
                        REFERENCE_MODAL_MESSAGES.STOPLIST_CONTRACT,
                      );
                      setShowReferenceModal(true);
                    } else {
                      setShowNewContract(true);
                    }
                  }}>
                  Создать договор
                </Box>
              </Affix>
            )}
            {active === 'references' && (
              <Affix
                hiddenFrom='sm'
                position={{ bottom: 34, right: 0, left: 0 }}
                w='fit-content'
                m='0 auto'
                style={{ display: 'flex', justifyContent: 'center' }}>
                <Box
                  p='12px'
                  h='48px'
                  w='214px'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    color: isDisabledLoadReference ? 'white' : '#8E9AA8',
                    borderRadius: '4px',
                    cursor: isDisabledLoadReference ? 'pointer' : 'not-allowed',
                    backgroundColor: isDisabledLoadReference ? '#002CFB' : '#f1f4f9',
                  }}
                  onClick={async () => {
                    if (worker?.worker_app === null) {
                      setReferenceModalContent(REFERENCE_MODAL_MESSAGES.NO_APP);
                      setShowReferenceModal(true);
                    } else if (
                      (worker?.worker_app?.fns_status ?? -1) <= 0 ||
                      worker?.worker_app?.fns_status === 3
                    ) {
                      setReferenceModalContent(REFERENCE_MODAL_MESSAGES.FNS_STATUS);
                      setShowReferenceModal(true);
                    } else if (isDisabledLoadReference) {
                      setIsLoadingReference(true);
                      try {
                        await downloanHandle();
                        if (referencesRefetch) {
                          await referencesRefetch();
                        }
                      } catch (error: unknown) {
                        const errorMessage =
                          (error instanceof Error && error.message) ||
                          (typeof error === 'string' && error) ||
                          'Ошибка загрузки справки';
                        if (errorMessage === '500') {
                          setReferenceModalContent(
                            REFERENCE_MODAL_MESSAGES.ERROR_DOWNLOAD_REFERENCE,
                          );
                          setShowReferenceModal(true);
                        } else {
                          setReferenceModalContent({
                            title: 'Невозможно сформировать справку',
                            text: errorMessage,
                          });
                          setShowReferenceModal(true);
                        }
                      } finally {
                        setIsLoadingReference(false);
                      }
                    }
                  }}>
                  {isLoadingReference ? 'Загрузка...' : <>Сформировать справку</>}
                </Box>
              </Affix>
            )}
            {tabs && <div className={styles.contentMobile}>{content[active]}</div>}
          </div>
        </div>
      </div>

      {showNewContract && (
        <Modal setOpen={setShowNewContract} open={showNewContract}>
          <CreateContractForm
            onComplete={({ id, number }) => {
              setShowNewContract(false);
              setShowConfirmModal(true);
              refetch();
              setContractData({ id, number });
            }}
            defaultWorker={worker?.id}
            workerSurname={isTetrika ? worker?.surname : null}
          />
        </Modal>
      )}
      {showConfirmModal && (
        <ModalConfirm
          setShowLogoutModal={setShowConfirmModal}
          title='Договор создан'
          onConfirm={() => {
            setShowNewContract(false);
          }}
          text='Договор отправлен на подпись исполнителю в приложение'
          subText={
            <span
              className={styles.root_subText}
              onClick={() => {
                handleDownloadContract();
                setIsLoadingDownloading(true);
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Договор {contractData?.number}
                {isLoadingDownloading && <Loader size='xs' color='#002cfb' />}
              </div>
            </span>
          }
          cancelText='Готово'
        />
      )}
      {isCreatedModalOpen && (
        <CreateEmployedsСategory
          variant='drawer'
          setIsShowFinishModal={setIsCreatedModalOpen}
          setShowCopiedSuccess={setShowCopiedSuccess}
        />
      )}
      {showCopiedSuccess && (
        <SuccessErrorInfo
          type='success'
          text='Создана новая категория'
          handleClose={handleCloseCopiedSuccess}
        />
      )}
      {showReferenceModal && (
        <ModalConfirm
          setShowLogoutModal={setShowReferenceModal}
          title={referenceModalContent.title}
          onConfirm={() => setShowReferenceModal(false)}
          text={referenceModalContent.text}
          cancelText='Закрыть'
        />
      )}
    </>
  );
};
